export interface LinkedInPost {
  id: number;
  date: string;
  content: string;
  image?: string;
  likes: number;
  comments: number;
  shares: number;
  hashtags: string[];
}

export const linkedInPosts: LinkedInPost[] = [
  {
    id: 1,
    date: 'May 18, 2026',
    content:
      "Just wrapped a 14-month engagement with a Series C healthtech platform — 23 engineers shipped, zero turnover, 99.97% uptime. Our Dedicated Team model meant the client had full-stack React + Node + FHIR specialists who understood HIPAA before Day 1.\n\nThe real win? The internal PM said our team felt like 'the in-house squad we never had to recruit.' That's the standard we hold ourselves to.",
    likes: 342,
    comments: 28,
    shares: 47,
    hashtags: ['#HealthTech', '#DedicatedTeams', '#FHIR', '#EngineeringExcellence'],
  },
  {
    id: 2,
    date: 'May 12, 2026',
    content:
      'We are now serving 10+ industries with 200+ domain-vetted engineers on the bench. From payment gateway rebuilds to multi-tenant SaaS architectures — if you can describe the problem, we have shipped the solution before.\n\nNew: Real-time talent availability dashboard now live on our site. See exactly who is available, their stack, and their last 3 projects.',
    likes: 518,
    comments: 41,
    shares: 89,
    hashtags: ['#TalentPool', '#SaaS', '#Fintech', '#Hiring'],
  },
  {
    id: 3,
    date: 'May 5, 2026',
    content:
      "Case study drop: How we helped a Fortune 500 retailer cut mobile cart abandonment from 68% to 12% in 8 weeks.\n\nThe secret was not 'more engineers.' It was the *right* engineers — two React Native leads who had already built checkout flows for 3 top-50 retail apps.\n\nDomain match rate: 98%. Time to first commit: 72 hours.",
    image:
      'https://readdy.ai/api/search-image?query=Professional%20business%20team%20collaborating%20in%20modern%20office%20with%20laptop%20screens%20showing%20analytics%20dashboards%20and%20retail%20metrics%2C%20warm%20natural%20lighting%2C%20corporate%20productivity%20scene%2C%20editorial%20photography%20style%20with%20shallow%20depth%20of%20field&width=1200&height=675&seq=linkedin-post-1&orientation=landscape',
    likes: 891,
    comments: 67,
    shares: 156,
    hashtags: ['#CaseStudy', '#RetailTech', '#ReactNative', '#Ecommerce'],
  },
  {
    id: 4,
    date: 'Apr 28, 2026',
    content:
      "Hiring senior Rust + WebAssembly engineers used to take 4-6 months. Our bench has 12 right now — and 4 of them have shipped zero-knowledge proof systems before.\n\nIf your roadmap includes zk-rollups, MPC wallets, or any bleeding-edge crypto infrastructure, we should talk. Not next quarter. This week.",
    likes: 267,
    comments: 19,
    shares: 34,
    hashtags: ['#Rust', '#WebAssembly', '#Blockchain', '#ZeroKnowledge'],
  },
  {
    id: 5,
    date: 'Apr 22, 2026',
    content:
      "We just crossed 500 successful engagements since founding. That is 500 teams that shipped faster, 500 CTOs who slept better, and 500 products that made it to market because the right people showed up at the right time.\n\nThank you to every client who trusted us, and every engineer who chose to build with us. On to the next 500.",
    likes: 1243,
    comments: 98,
    shares: 234,
    hashtags: ['#Milestone', '#500Engagements', '#Grateful', '#Scale'],
  },
];